import { BaseApiResponse } from '../../../api/types';

export const makeErrorText = (object: BaseApiResponse<any>) => {
    return `Error(code: ${object.errorCode}, message: ${object.message})`;
};
